(function () {
    'use strict';

    angular.module("imApp").factory("businessCoAccountingService", ['$ihttp', function ($ihttp) {
        let service = {
            getBusinessCoAccounting: function (parms) {
                return $ihttp.post({
                    method: 2952,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2953,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
